import React, { FC } from 'react';
import './LoadMoreButton.css';
import { FaSistrix } from 'react-icons/fa';

interface LoadMoreButtonProps {
	onClick: () => void;
	batchCapacity: number;
}

const LoadMoreButton: FC<LoadMoreButtonProps> = ({ onClick, batchCapacity }) => (
	<div className="LoadMoreButton DataCardList__load-more-button" data-testid="LoadMoreButton">
		<button className="load-more-button with-icon" onClick={onClick}>
			<FaSistrix/> <span>Charger {batchCapacity} de plus...</span>
		</button>
	</div>
);

export default LoadMoreButton;
